import { FC } from 'react'
import { styled } from '../../../../lib/stitches'
import { MediaTypes } from '../../../core/Utils'
import { gray1, gray15, gray3 } from '../../../platform/color'
import { capitalize } from './utils'

const StyledTabsContainer = styled('div', {
  padding: '0px 32px',
  borderBottom: `1px solid ${gray3}`,
  background: gray1,
  zIndex: 1,
  display: 'flex'
})

const StyledTab = styled('button', {
  all: 'unset',
  color: gray15,
  opacity: 0.6,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '18px',
  padding: '16px',
  minWidth: '80px',
  textAlign: 'center',
  transition: 'all 150ms ease',
  position: 'relative',
  '&:hover': {
    opacity: 1
  },
  variants: {
    active: {
      true: {
        opacity: 1,
        '&::after': {
          position: 'absolute',
          content: '',
          left: 0,
          right: 0,
          bottom: '-1px',
          height: '2px',
          background: gray15
        }
      }
    }
  }
})

export const Tabs = StyledTabsContainer
export const Tab = StyledTab

interface ExploreTabsProps {
  onTabChange?: (tab: string) => void
  activeTab?: string
  tabs: string[]
}

const ExploreTabs: FC<ExploreTabsProps> = ({ onTabChange, activeTab, tabs }) => {
  return (
    <Tabs css={{ position: 'sticky', top: 0 }}>
      {tabs.map((tab, i) => (
        <Tab key={i} active={activeTab === tab} onClick={() => onTabChange(tab)}>
          {tab === MediaTypes.STEMS ? 'Loops' : capitalize(tab)}
        </Tab>
      ))}
    </Tabs>
  )
}

export default ExploreTabs
